import { useOktaAuth } from '@okta/okta-react';
import React, { FC } from 'react';
import { Redirect } from 'react-router-dom';
import { AccountAPI } from 'api/account';
import { PageLoading } from 'components/atoms/loading';
import { LoginPage } from 'components/organisms/login';
import { TokenError, TokenErrorStatus } from 'components/organisms/token-error';
import { useQueryParams } from 'hooks/use-query-params';
import { ActiveTab, TokenType } from 'services';
import { getTokenMeta } from 'utils/token';
import { LoginWithToken } from '../login-with-token';

export const Login: FC = () => {
  const { authState } = useOktaAuth();
  const params = useQueryParams();
  const token = params.get('token') ?? '';
  const extToken = params.get('rl-token') ?? '';
  const { isExpired, decoded } = getTokenMeta(token);

  if (decoded && isExpired) {
    return (
      <TokenError
        status={TokenErrorStatus.Expired}
        email={decoded.emailId}
        resendEmail={() => AccountAPI.forgotAccount({ email: decoded.emailId })}
      />
    );
  }

  return !authState ? (
    <PageLoading />
  ) : authState.isAuthenticated ? (
    <Redirect
      to={
        /**
         * Active tab saves the entire url, not the pathname alone
         * TODO: remove URL construct when saving the pathname instead of url
         */
        new URL(ActiveTab.pop() ?? window.location.origin).href.replace(
          window.location.origin,
          '',
        )
      }
    />
  ) : token || extToken ? (
    <LoginWithToken
      token={token || extToken || ''}
      tokenType={extToken ? TokenType.External : TokenType.Rocketlane}
    />
  ) : (
    <LoginPage />
  );
};
